module.exports = fox._r("fonts/tags-filter.woff?3lzqzp", __webpack_public_path__ + "_/_/_/root/fonts/29qOVyH.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/tags-filter.woff?3lzqzp
// module id = 444
// module chunks = 4